import * as types from "./actionTypes";
import initialState from "reducers/initialState";
import { FACILITY_HEADER_INVALIDATED } from "../edit/generalData/eventTypes";

const facilityListReducer = (state = initialState.facilities.list, action) => {
  switch (action.type) {
    case types.LOAD_FACILITIES_STARTED: {
      const { key, page, pageSize } = action;
      let result = { ...state };
      result[key] = { ...state[key], pageSize };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITIES_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };

      return result;
    }

    case types.LOAD_FACILITIES_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };

      return result;
    }

    case FACILITY_HEADER_INVALIDATED: {
      return {};
    }

    default:
      return state;
  }
};

export default facilityListReducer;
